
import { Button } from "@/components/ui/button";
import { Download, Share2, History, Mail, PenTool, Shield } from "lucide-react";
import type { Document } from "../DocumentCard";

interface DocumentActionsProps {
  document: Document;
  onDownload: (doc: Document) => void;
  onShare?: (doc: Document) => void;
  onVersionHistory?: (doc: Document) => void;
  onShowShareDialog: () => void;
  onShowSigningDialog: () => void;
  onAnalyze: () => void;
  isAnalyzing: boolean;
}

export function DocumentActions({
  document,
  onDownload,
  onShare,
  onVersionHistory,
  onShowShareDialog,
  onShowSigningDialog,
  onAnalyze,
  isAnalyzing
}: DocumentActionsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onDownload(document)}
        className="flex items-center gap-2"
      >
        <Download className="h-4 w-4" />
        Last ned
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onShowShareDialog}
        className="flex items-center gap-2"
      >
        <Mail className="h-4 w-4" />
        Del via e-post
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onShowSigningDialog}
        className="flex items-center gap-2"
      >
        <PenTool className="h-4 w-4" />
        Send til signering
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onAnalyze}
        disabled={isAnalyzing}
        className="flex items-center gap-2"
      >
        <Shield className="h-4 w-4" />
        {isAnalyzing ? 'Analyserer...' : 'Analyser dokument'}
      </Button>
      {onShare && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => onShare(document)}
          className="flex items-center gap-2"
        >
          <Share2 className="h-4 w-4" />
          Del
        </Button>
      )}
      {onVersionHistory && (
        <Button
          variant="outline"
          size="sm"
          onClick={() => onVersionHistory(document)}
          className="flex items-center gap-2"
        >
          <History className="h-4 w-4" />
          Versjoner
        </Button>
      )}
    </div>
  );
}
